import React from "react"
import DownloadIcon from '@mui/icons-material/Download'
import {useTranslation} from "react-i18next"
import {useSnackbar} from "notistack"

import Fab from "../../../../../../components/Fab"
import {downloadEstimateBackups} from '../../../../../../api/estimate'


interface EstimateBackupsButtonProps {
  projectId: string,
  estimateId: string,
}

export default function EstimateBackupsButton({projectId, estimateId}: EstimateBackupsButtonProps) {
  const { t } = useTranslation("private")
  const { enqueueSnackbar } = useSnackbar()

  const downloadBackups = async () => {
    try {
      const res = await downloadEstimateBackups(projectId, estimateId)
      if (res.status === 200 && res.data.success) {
        enqueueSnackbar(
          t("view.Estimates.SingleEstimate.EstimateBackupsButton.success"),
          {variant: 'success'}
        )
        return
      }
      enqueueSnackbar(
        t("view.Estimates.SingleEstimate.EstimateBackupsButton.error"),
        {variant: 'error'}
      )
    } catch (e: any) {
      const res = e.response
      if (res.status === 400 && typeof(res.data) === 'string') {
        if (res.data.includes('does not have any tickets')) {
          enqueueSnackbar(
            t("view.Estimates.SingleEstimate.EstimateBackupsButton.noTix"),
            {variant: 'info'}
          )
          return
        }
      }
      enqueueSnackbar(
        t("view.Estimates.SingleEstimate.EstimateBackupsButton.error"),
        {variant: 'error'}
      )
    }
  }

  return (
    <Fab
      // @ts-ignore
      edge="end"
      size="medium"
      style={{color: "white", backgroundColor: "#143366"}}
      variant="extended"
      onClick={downloadBackups}
    >
      <DownloadIcon />
      {t("view.Estimates.SingleEstimate.EstimateBackupsButton.buttonText")}
    </Fab>
  )
}
